// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1xLJH","log":"ModalInventoryLogs_log__2QN8v","date":"ModalInventoryLogs_date__2KkIB","userName":"ModalInventoryLogs_userName__3n_b7"};